import * as RasaInput from '../../components/rasa-input'
import {ApplicationState} from '../../rootReducer'
import * as Constants from './constants'
import * as Types from './types'

export const filterGrid = (domains: Types.Domain[], filterValue: string) => {
  if (filterValue === Constants.ALL.description) {
    return domains
  } else {
    return domains.filter( (d: Types.Domain) => d.validation === filterValue)
  }
}

export const getUrlFilter = (state: ApplicationState) => state.domainAuthentication.data.validationStatus.value

export const formatCnames = (cnameHash: Types.CnamesHash): string => {
  let str = ''
  Object.keys(cnameHash).forEach( (cnameKey) => {
    str += `${cnameHash[cnameKey].host} -> ${cnameHash[cnameKey].data}\n`
    })
  return str;
}

export const modalStateValid = (domain: string, justSubmitted: boolean): boolean => {
  if ( (RasaInput.validateDomain(domain).invalid) || justSubmitted) {
     return true
    }
  return false
}

export const changeDomainStatus = (
  domains: Types.Domain[], id: number, status: string) => {
  const index = domains.findIndex((obj: Types.Domain) => obj.id === id )
  domains[index].validation = status
  return domains;
}

export const setFilterAfterUrl = (filterStatus: string) => {
  if (filterStatus === 'Pending') {
    return Constants.PENDING
  }
  if (filterStatus === 'Verified') {
    return Constants.VERIFIED
  }
  if (filterStatus === 'Failed') {
    return Constants.FAILED
  }
  if (filterStatus === 'All') {
    return Constants.ALL
  }
}



// WEBPACK FOOTER //
// ./src/pages/domain-authentication/utils.ts